const baseParams = {
  currentPage: "1",
  items: "12",
  sorting: "introducedAt",
};

export const openForTestingParams = new URLSearchParams({
  ...baseParams,
  lockedTestableProducts: "true",
});

export const limitedTimeOffersParams = new URLSearchParams({
  ...baseParams,
  onlyGroupsOnSale: "true",
});

export const lockedOnlyParams = new URLSearchParams({
  ...baseParams,
  merchantLockedOnly: "true",
});

export const newArrivalsParams = new URLSearchParams({
  ...baseParams,
});

export const bestSellingParams = new URLSearchParams({
  ...baseParams,
  featureGroupId: "1",
  featureGroupTitle: "Best selling products",
});
